import { useState, useMemo, useCallback } from "react";
import { PinkBaseButton, SECONDARY, PRIMARY } from "components/buttons/PinkBaseButton";
import { ReactComponent as PlusIcon } from "../icons/plusIcon.svg";
import { nFormatter } from "../../utils/parseNumber";
import { clsx } from "clsx";
import "./SelectTags.scss";

interface IProps {
  tags: any[];
  expanded?: boolean;
  showAmount?: boolean;
  setTags: (tags: any) => void;
  mainSelectedTags: string[];
  invertColor?: boolean;
}

const PAGE_SIZE = 30;

const SelectTags = (props: IProps) => {
  const { tags, expanded, showAmount, setTags, mainSelectedTags: selectedTags, invertColor } = props;
  const [page, setPage] = useState(2);
  const mainSelectedTags = useMemo(() => selectedTags || [], [selectedTags]);

  const amountOfShrinkedTags = PAGE_SIZE * page;

  const paginatedTags = useMemo(() => {
    if (!tags) {
      return [];
    }

    const newTags = tags.slice(0, PAGE_SIZE * page);

    return newTags.filter((tag: any) => !mainSelectedTags.includes(tag.name));
  }, [tags, mainSelectedTags, page]);

  const handleTagClick = useCallback((tag: any) => {
    let tagText = tag.name;
    if (showAmount && tag.name) {
      tagText = tag.name;
    }

    if (tagText !== null) {
      setTags([...mainSelectedTags, tagText]);
    } else {
      // eslint-disable-next-line
      console.warn("Oops, an empty tag clicked.");
    }
  }, [showAmount, mainSelectedTags, setTags]);

  const onMoreClick = () => {
    setPage(page + 1);
  };

  const handleTagDelete = useCallback((tag: any) => {
    if (mainSelectedTags.includes(tag)) {
      setTags(
        mainSelectedTags.filter((t: any) => t !== tag)
      );
    }
  }, [mainSelectedTags, setTags]);

  return (
    <div id="tagsblock" className={clsx("SelectTags", !!expanded && "SelectTags_isExpanded")}>
      {mainSelectedTags && mainSelectedTags?.map((el: any, index: number) => (
        <div key={el} className={clsx(
          "SelectTags-Button",
          invertColor && "SelectTags-Button_isInverted",
          "SelectTags-Button_isSelected"
        )}>
          <PinkBaseButton
            variant={PRIMARY}
            onClick={() => handleTagDelete(el)}
          >
            {el}
          </PinkBaseButton>
        </div>
      ))}
      {(tags && tags.length > 0) ? paginatedTags?.map((tag: any, index: number) =>
        <div key={tag.name} className={clsx(
          "SelectTags-Button",
          invertColor && "SelectTags-Button_isInverted",
          (index > amountOfShrinkedTags) && "SelectTags-Button_isHide",
        )}>
          <PinkBaseButton
            variant={SECONDARY}
            onClick={() => handleTagClick(tag)}
          >
            {showAmount ? (
              <p>{tag.name}{showAmount && <span>{nFormatter(tag.count)}</span> }</p>
            ) : tag.name}
          </PinkBaseButton>
        </div>
      ) : <p style={{ fontSize: "14px" }}>We have some issues with loading tags. Please close and open the dialog and try again.</p>}
      {tags.length > 3 && !expanded ?
        <div className="SelectTags-ButtonMore">
          <PinkBaseButton onClick={onMoreClick}>
            <PlusIcon />
          </PinkBaseButton>
        </div> : null}
    </div>
  );
};

export default SelectTags;
